<template>
  <div>
    <div class="scenario_part retiremod scenario_bgs longmod">
      <div class="container">

        <div class="scenario_form">
          <div class="form_outter">
            <div class="form_top">
              <p>退休沒有那麼難～現在就來透視一下吧！</p>
              <div class="top_img">
                <img src="@/assets/images/needs/banner-retire/form_people.svg" alt="">
              </div>
            </div>
            <div class="form_list">
              <div class="row">
                <div class="col-xs-12 form-group from_main flex">
                  <p class="flex_text">出生年月日 (民國)
                    <a href="javascript:void(0);" data-html="true" data-tooltip=""></a></p>
                  <div class="flex_box flex">
                    <div class="select_arrow age birthday">
                      <select
                          id="birth_y"
                          class="birth_change pretty-select"
                          v-model.number="birthdayY"
                      >
                        <option v-for="year in yearsRange">{{ year }}</option>
                      </select>
                    </div>
                    <div class="select_arrow age birthday">
                      <select
                          id="birth_m"
                          class="birth_change pretty-select"
                          v-model.number="birthdayM"
                      >
                        <option v-for="M in 12">{{ M }}</option>
                      </select>
                    </div>

                    <div class="select_arrow age birthday"
                    >
                      <select
                          id="birth_d"
                          class="pretty-select"
                          v-model.number="birthdayD"
                      >
                        <option v-for="D in daysRange">{{ D }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex">
                  <p class="radioTitle flex_text">性別</p>
                  <div class="flex_box r-radio flex">
                    <div class="gender">
                      <input type="radio" id="men" name="gender" v-model="gender" value="MALE">
                      <label for="men"><span class="remind"></span> 男性</label>
                    </div>
                    <div class="gender">
                      <input type="radio" id="women" name="gender" v-model="gender" value="FEMALE">
                      <label for="women"> <span class="remind"></span> 女性</label>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex"
                     :class="{
                  error:$v.startWorkAge.$anyError ||
                  cantBigger ||
                  !$v.startWorkAge.between
                }">
                  <p class="radioTitle flex_text">開始工作年齡</p>
                  <div class="scenario_input">
                    <input class="flex_box"
                           type="number"
                           placeholder="大學畢業多為 22 歲"
                           v-model.number.lazy="startWorkAge"
                           oninput="value=value.match(/-?[0-9]*\.?[0-9]*/)">
                    <label data-domain="歲"></label>
                    <div class="error_text" v-if="cantBigger">咦？你還沒工作就退休了嗎？</div>
                    <div class="error_text" v-if="!$v.startWorkAge.required && $v.startWorkAge.$dirty ">
                      開始工作的年齡通常為 16～40 歲
                    </div>
                    <div class="error_text"
                         v-if="!$v.startWorkAge.between">開始工作年齡必須介於
                      {{ $v.startWorkAge.$params.between.min }} ~
                      {{ $v.startWorkAge.$params.between.max }}歲
                    </div>
                    <div class="error_text" v-if="cantBigger3">
                      咦？你還沒開始工作嗎
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex"
                     :class="{error:$v.estimateRetireAge.$anyError || cantBigger2}">
                  <p class="radioTitle flex_text">預計退休年齡</p>
                  <div class="scenario_input">
                    <input class="flex_box"
                           type="number"
                           placeholder="通常為 65 歲"
                           v-model.number.lazy="$v.estimateRetireAge.$model"
                           oninput="value=value.match(/-?[0-9]*\.?[0-9]*/)">
                    <label data-domain="歲"></label>
                    <div class="error_text" v-if="!$v.estimateRetireAge.required && $v.estimateRetireAge.$dirty">
                      退休年齡通常為 40～77 歲
                    </div>
                    <div class="error_text" v-if="cantBigger2">
                      咦？你已經退休了耶
                    </div>
                    <div class="error_text" v-if="!$v.estimateRetireAge.between">預計退休年齡必須介於
                      {{ $v.estimateRetireAge.$params.between.min }} ~ {{ $v.estimateRetireAge.$params.between.max }}歲
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex " :class="{error:$v.currentSalary.$anyError}">
                  <p class="radioTitle flex_text">目前薪資</p>
                  <div class="scenario_input">
                    <input class="flex_box"
                           placeholder=""
                           v-model="salaryFormat"
                           oninput="value=value.replace(/[^\d\,]/g, '')"
                    >
                    <label data-domain="元／月"></label>
                    <div class="error_text" v-if="!$v.currentSalary.required && $v.currentSalary.$dirty">
                      你目前的薪資是分析的重點哦～
                    </div>
                    <div class="error_text" v-if="!$v.currentSalary.between">每月薪資必須介於
                      {{ $v.currentSalary.$params.between.min }} ~ {{ $v.currentSalary.$params.between.max }}
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex " :class="{error:$v.alreadyPrepare.$anyError}">
                  <p class="radioTitle flex_text">目前已累積退休金</p>
                  <div class="scenario_input">
                    <input class="flex_box"
                           placeholder="存款、股利、房租..."
                           v-model="alreadyPrepareFormat"
                           oninput="value=value.replace(/[^\d\,]/g, '')"
                    >
                    <label data-domain="元"></label>
                    <div class="error_text" v-if="!$v.alreadyPrepare.required && $v.alreadyPrepare.$dirty">
                      輸入已存退休金才能準確分析哦～
                    </div>
                    <div class="error_text" v-if="!$v.alreadyPrepare.between">已備退休金必須介於
                      {{ $v.alreadyPrepare.$params.between.min }} ~ {{ $v.alreadyPrepare.$params.between.max }}
                    </div>
                  </div>

                </div>


                <div class="col-xs-6 col-xs-offset-3 form-group">
                  <div class="share_btn share_btn_blueDefault">
                    <a v-if="!isLoading" @click.prevent="toNext()"
                       href="#">查看結果 Go </a>
                    <a v-if="isLoading" href="">
                      <i class='fa fa-spinner fa-spin'></i> 處理中
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProgressBar :page="page"></ProgressBar>
  </div>
</template>

<script>
import moment from 'moment'
import router from "@/router";
import {required, between, integer} from 'vuelidate/lib/validators'
import GA from "@/func/seo";
import ProgressBar from '@/components/common/progress_bar'

export default {
  name: "retire_form",
  components: {ProgressBar},
  data: function () {
    return {
      isLoading: false,
      birthdayY: 79,
      birthdayM: 10,
      birthdayD: 22,
      yearsRange: [],
      gender: 'MALE',
      startWorkAge: '',
      estimateRetireAge: '',
      currentSalary: '',
      alreadyPrepare: '',
      submitStatus: 'OK',
      page: {
        page_no: 6,
        total: 6,
        isRetire: true
      }
    }
  },
  validations: {
    startWorkAge: {
      integer,
      required,
      between: between(16, 40),
    },
    estimateRetireAge: {
      integer,
      required,
      between: between(40, 77)
    },
    currentSalary: {
      integer,
      required,
      between: between(0, 500000)
    },
    alreadyPrepare: {
      integer,
      required,
      between: between(0, 200000000)
    }
  },
  methods: {
    toNext() {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.cantBigger && !this.cantBigger2 && !this.cantBigger3) {
        this.sendFormData()
      }
    },
    setBirthday() {
      let today = new Date();
      this.birthdayY = today.getFullYear() - 1911 - 30
      this.birthdayM = today.getMonth() + 1
      this.birthdayD = today.getDate()
    },
    setYearsRange() {
      let a = []
      let nDate = new Date()
      let yearMax = nDate.getFullYear() - 1911 - 18;
      let yearMin = yearMax - 47;
      for (let i = yearMin; i <= yearMax; i++) a.push(i)
      return this.yearsRange = a
    },
    async sendFormData() {
      this.isLoading = true
      let wantCost = store.get('retire/getWantCost')
      let data = {
        currentAge: this.currentAge,
        gender: this.gender,
        startWorkAge: this.startWorkAge,
        estimateRetireAge: this.estimateRetireAge,
        currentSalary: this.currentSalary,
        alreadyPrepare: this.alreadyPrepare,
        wantCostAfterRetirePerMonth: wantCost,
      }
      await store.dispatch('retire/sendRetireApi', data)
      await store.dispatch('retire/sendSBCombinePremiumApi')
      await store.dispatch('retire/sendSBApi').then(res => {
        // 使用直接頁面跳轉而非 router.push
        window.location.href = `/needs_analysis/retire/result/${res}`;
      })
      this.isLoading = false
    },
    setName(value) {
      this.name = value
      this.$v.name.$touch()
    },
    setAge(value) {
      this.age = value
      this.$v.age.$touch()
    },
    currency(value) {
      var num = (value || 0).toString(),
          result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-');
      return result;
    },
  },
  computed: {
    daysRange: (data) => {
      return Array.from(Array(moment(`${data.birthdayY + 1911}${data.birthdayM}`).daysInMonth()), (_, i) => i + 1)
    },
    currentAge: (data) => {
      let nDate = new Date();
      let n_y = nDate.getFullYear();
      let n_m = nDate.getMonth() + 1;
      let n_d = nDate.getDate();
      let b_y = data.birthdayY + 1911;
      let b_m = data.birthdayM;
      let b_d = data.birthdayD;
      let nD = n_y + '-' + n_m + '-' + n_d;
      let bD = b_y + '-' + b_m + '-' + b_d;
      let nM = moment(nD, 'YYYY-MM-DD');
      let bM = moment(bD, 'YYYY-MM-DD');
      let r_age = nM.diff(bM, 'years', true);
      return Math.round(r_age)
    },
    cantBigger: (data) => {
      if (data.startWorkAge && data.estimateRetireAge) return data.startWorkAge + 1 > data.estimateRetireAge
    },
    cantBigger2: (data) => {
      if (data.currentAge > data.estimateRetireAge && data.$v.estimateRetireAge.$dirty) {
        if (data.estimateRetireAge !== '') return true
      }
    },
    cantBigger3: (data) => data.startWorkAge > data.currentAge ,
    salaryFormat: {
      set(value) {
        if (value === '0' || value === 0 || !value) {
          this.currentSalary = ''
        } else {
          this.currentSalary = parseInt(value.replace(/[,]/g, ""))
        }
      },
      get() {
        if (this.currency(this.currentSalary) === '0') {
          return ''
        }
        return this.currency(this.currentSalary)
      }
    },
    alreadyPrepareFormat: {
      set(value) {
        if (value === '0' || value === 0 || !value) {
          this.alreadyPrepare = ''
        } else {
          this.alreadyPrepare = parseInt(value.replace(/[,]/g, ""))
        }
      },
      get() {
        if (this.currency(this.alreadyPrepare) === '0') {
          return ''
        }
        return this.currency(this.alreadyPrepare)
      }
    },
  },
  mounted() {
    GA.pushRetireEvent('form', '退休沒有那麼難～現在就來透視一下吧！')
    this.setYearsRange();
    this.setBirthday();
  }

}

</script>